import { HttpParams } from '@angular/common/http';

type HttpParamValue = string | number | boolean | string[] | number[];
type HttpParamsSource = Record<string, HttpParamValue | null | undefined>;

function isPresent(
  value: HttpParamValue | null | undefined,
): value is HttpParamValue {
  return (
    value !== undefined &&
    value !== null &&
    value !== '' &&
    !(Array.isArray(value) && value.length === 0)
  );
}

export function buildHttpParams(source: HttpParamsSource): HttpParams {
  let params = new HttpParams();

  Object.keys(source).forEach(key => {
    const value = source[key];
    if (!isPresent(value)) {
      return;
    }

    if (Array.isArray(value)) {
      value.forEach(item => {
        params = params.append(key, item);
      });
    } else {
      params = params.append(key, value);
    }
  });

  return params;
}
